module.exports = __webpack_public_path__ + "static/img/格物智安工地安全管理平台操作说明-1.c810ad1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/documentation/格物智安工地安全管理平台操作说明-1.jpg
// module id = GF/2
// module chunks = 0